import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/efashion-blanc.png'


const _hoisted_1 = {
  tabindex: "-1",
  id: "sidebarMenu",
  "aria-labelledby": "sidebarMenuLabel"
}
const _hoisted_2 = { class: "sidebar-header sidebar-header-adminEFP" }
const _hoisted_3 = {
  key: 0,
  class: "sidebar-adminEFP-badge"
}
const _hoisted_4 = { class: "sidebar-content" }
const _hoisted_5 = { class: "sidebar-nav" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = ["aria-expanded"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = { key: 5 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = ["aria-expanded"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { key: 4 }
const _hoisted_23 = { key: 4 }
const _hoisted_24 = ["aria-expanded"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 5 }
const _hoisted_28 = ["aria-expanded"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { key: 3 }
const _hoisted_33 = { key: 4 }
const _hoisted_34 = { key: 5 }
const _hoisted_35 = { key: 6 }
const _hoisted_36 = { key: 6 }
const _hoisted_37 = ["aria-expanded"]
const _hoisted_38 = { key: 7 }
const _hoisted_39 = {
  key: 8,
  class: "access-management-item"
}
const _hoisted_40 = { key: 9 }
const _hoisted_41 = { class: "sidebar-collapsed-icons" }
const _hoisted_42 = ["title"]

import { computed, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { useAdminEfpStore } from "@/stores/adminEfp";
import type { AdminPermissionKey } from "@/config/adminPermissions";

interface Props {
  isSidebarOpen: boolean;
  isSidebarCollapsed: boolean;
  vendeurData: any;
}

interface Emits {
  (e: "toggle-sidebar"): void;
}

type CollapseSection =
  | "clients"
  | "orders"
  | "billing"
  | "content"
  | "shooting";


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminSidebar',
  props: {
    isSidebarOpen: { type: Boolean },
    isSidebarCollapsed: { type: Boolean },
    vendeurData: {}
  },
  emits: ["toggle-sidebar"],
  setup(__props: any, { emit: __emit }) {

const authStore = useAuthStore();
const adminEfp = useAdminEfpStore();

const props = __props;
const emit = __emit;

const router = useRouter();

const isCollapseOpen = ref<Record<CollapseSection, boolean>>({
  clients: false,
  orders: false,
  billing: false,
  content: false,
  shooting: false,
});

const canSeeClients = computed(
  () =>
    adminEfp.canAccess("clients") ||
    adminEfp.canAccess("top-acheteurs") ||
    adminEfp.canAccess("nouveaux-acheteurs") ||
    adminEfp.canAccess("grossistes-a-recontacter") ||
    adminEfp.canAccess("code-promos")
);

const canSeeOrders = computed(
  () =>
    adminEfp.canAccess("orders") ||
    adminEfp.canAccess("groupages") ||
    adminEfp.canAccess("ruptures") ||
    adminEfp.canAccess("litige-retour")
);

const canSeeBilling = computed(
  () =>
    adminEfp.canAccess("facturation") ||
    adminEfp.canAccess("vendeur-facturation")
);

const canSeeContent = computed(
  () =>
    adminEfp.canAccess("actualites") ||
    adminEfp.canAccess("mel-template") ||
    adminEfp.canAccess("cms") ||
    adminEfp.canAccess("couleurs")
);

const SECTION_PERMISSIONS: Record<CollapseSection, AdminPermissionKey[]> = {
  clients: [
    "clients",
    "top-acheteurs",
    "nouveaux-acheteurs",
    "grossistes-a-recontacter",
    "code-promos",
  ],
  orders: ["orders", "groupages", "ruptures", "litige-retour"],
  billing: ["facturation", "vendeur-facturation"],
  content: ["actualites", "mel-template", "cms", "couleurs"],
  shooting: ["shooting"],
};

const PATH_TO_SECTION: Array<{ prefix: string; section: CollapseSection }> = [
  { prefix: "/adminEFP/nouveaux-comptes", section: "clients" },
  { prefix: "/adminEFP/acheteur-statement", section: "clients" },
  { prefix: "/adminEFP/hipay", section: "clients" },
  { prefix: "/adminEFP/vendeur-fiche", section: "clients" },
  { prefix: "/adminEFP/top-acheteurs", section: "clients" },
  { prefix: "/adminEFP/nouveaux-acheteurs", section: "clients" },
  { prefix: "/adminEFP/grossistes-a-recontacter", section: "clients" },
  { prefix: "/adminEFP/code-promos", section: "clients" },
  { prefix: "/adminEFP/cms", section: "content" },
  { prefix: "/adminEFP/store-prestations", section: "content" },
  { prefix: "/adminEFP/orders", section: "orders" },
  { prefix: "/adminEFP/groupages", section: "orders" },
  { prefix: "/adminEFP/groupage-detail", section: "orders" },
  { prefix: "/adminEFP/commandes-rupture", section: "orders" },
  { prefix: "/adminEFP/litige-retour", section: "orders" },
  { prefix: "/adminEFP/facturation", section: "billing" },
  { prefix: "/adminEFP/vendeur-facturation", section: "billing" },
  { prefix: "/adminEFP/actualites", section: "content" },
  { prefix: "/adminEFP/couleurs", section: "content" },
  { prefix: "/adminEFP/mel-template", section: "content" },
  { prefix: "/adminEFP/shooting", section: "shooting" },
  { prefix: "/adminEFP/pickupreturn", section: "shooting" },
];

function sectionForPath(path: string): CollapseSection | null {
  for (const { prefix, section } of PATH_TO_SECTION) {
    if (path === prefix || path.startsWith(`${prefix}/`)) {
      return section;
    }
  }
  return null;
}

function openSection(section: CollapseSection) {
  Object.keys(isCollapseOpen.value).forEach((key) => {
    isCollapseOpen.value[key as CollapseSection] = false;
  });
  isCollapseOpen.value[section] = true;
}

const toggleSidebar = () => {
  emit("toggle-sidebar");
};

const toggleCollapse = (section: CollapseSection) => {
  if (isCollapseOpen.value[section]) {
    isCollapseOpen.value[section] = false;
  } else {
    openSection(section);
  }
};

const navigateTo = (routeName: string) => {
  router.push({ name: routeName });
};

const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

watch(
  () => router.currentRoute.value.fullPath,
  (path) => {
    const section = sectionForPath(path);
    if (section) {
      const permissions = SECTION_PERMISSIONS[section];
      if (permissions.some((key) => adminEfp.canAccess(key))) {
        openSection(section);
      }
    }
    if (isMobile() && props.isSidebarOpen) {
      emit("toggle-sidebar");
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["sidebar sidebar-adminEFP", { 'is-open': _ctx.isSidebarOpen, 'is-collapsed': _ctx.isSidebarCollapsed }])
  }, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: _unref(adminEfp).firstAccessiblePath(),
          class: "sidebar-logo"
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Logo Efashion"
            }, null, -1)
          ])),
          _: 1,
          __: [7]
        }, 8, ["to"]),
        _createElementVNode("button", {
          onClick: toggleSidebar,
          class: "sidebar-close-btn",
          "aria-label": "Fermer le menu"
        }, _cache[8] || (_cache[8] = [
          _createElementVNode("span", null, "×", -1)
        ]))
      ]),
      (
          _unref(authStore).isImpersonating &&
          _unref(authStore).impersonationDisplayName &&
          !_ctx.isSidebarCollapsed
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " ADMIN : " + _toDisplayString(_unref(authStore).impersonationDisplayName), 1))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", null, [
            (_unref(adminEfp).canAccess('dashboard'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                  _createVNode(_component_router_link, { to: "/adminEFP/dashboard" }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createElementVNode("i", { class: "fas fa-chart-pie" }, null, -1),
                      _createTextVNode(" Tableau de bord ")
                    ])),
                    _: 1,
                    __: [9]
                  })
                ]))
              : _createCommentVNode("", true),
            (_unref(adminEfp).canAccess('statistiques'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                  _createVNode(_component_router_link, { to: "/adminEFP/statistiques" }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createElementVNode("i", { class: "fas fa-chart-bar" }, null, -1),
                      _createTextVNode(" Statistiques ")
                    ])),
                    _: 1,
                    __: [10]
                  })
                ]))
              : _createCommentVNode("", true),
            (canSeeClients.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                  _createElementVNode("span", {
                    class: "sidebar-collapse-trigger",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleCollapse('clients'))),
                    "aria-expanded": isCollapseOpen.value.clients,
                    "aria-controls": "collapseClientsMenu"
                  }, _cache[11] || (_cache[11] = [
                    _createElementVNode("span", null, [
                      _createElementVNode("i", { class: "fas fa-users" }),
                      _createTextVNode("Clients")
                    ], -1),
                    _createElementVNode("i", { class: "chevron fas fa-chevron-right" }, null, -1)
                  ]), 8, _hoisted_9),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sidebar-collapse-content", isCollapseOpen.value.clients ? 'is-open' : 'is-closed']),
                    id: "collapseClientsMenu"
                  }, [
                    _createElementVNode("ul", null, [
                      (_unref(adminEfp).canAccess('clients'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                            _createVNode(_component_router_link, { to: "/adminEFP/nouveaux-comptes" }, {
                              default: _withCtx(() => _cache[12] || (_cache[12] = [
                                _createTextVNode("Gestion des clients")
                              ])),
                              _: 1,
                              __: [12]
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(adminEfp).canAccess('clients'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                            _createVNode(_component_router_link, { to: "/adminEFP/acheteur-statement" }, {
                              default: _withCtx(() => _cache[13] || (_cache[13] = [
                                _createTextVNode("Extraits de compte acheteurs")
                              ])),
                              _: 1,
                              __: [13]
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(adminEfp).canAccess('top-acheteurs'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                            _createVNode(_component_router_link, { to: "/adminEFP/top-acheteurs" }, {
                              default: _withCtx(() => _cache[14] || (_cache[14] = [
                                _createTextVNode("Top Acheteur")
                              ])),
                              _: 1,
                              __: [14]
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(adminEfp).canAccess('nouveaux-acheteurs'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                            _createVNode(_component_router_link, { to: "/adminEFP/nouveaux-acheteurs" }, {
                              default: _withCtx(() => _cache[15] || (_cache[15] = [
                                _createTextVNode("Nouveaux acheteurs")
                              ])),
                              _: 1,
                              __: [15]
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(adminEfp).canAccess('grossistes-a-recontacter'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                            _createVNode(_component_router_link, { to: "/adminEFP/grossistes-a-recontacter" }, {
                              default: _withCtx(() => _cache[16] || (_cache[16] = [
                                _createTextVNode("Grossistes à recontacter")
                              ])),
                              _: 1,
                              __: [16]
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(adminEfp).canAccess('code-promos'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                            _createVNode(_component_router_link, { to: "/adminEFP/code-promos" }, {
                              default: _withCtx(() => _cache[17] || (_cache[17] = [
                                _createTextVNode("Codes promos")
                              ])),
                              _: 1,
                              __: [17]
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            (canSeeOrders.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                  _createElementVNode("span", {
                    class: "sidebar-collapse-trigger",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleCollapse('orders'))),
                    "aria-expanded": isCollapseOpen.value.orders,
                    "aria-controls": "collapseOrdersMenu"
                  }, _cache[18] || (_cache[18] = [
                    _createElementVNode("span", null, [
                      _createElementVNode("i", { class: "fas fa-clipboard-list" }),
                      _createTextVNode("Commandes")
                    ], -1),
                    _createElementVNode("i", { class: "chevron fas fa-chevron-right" }, null, -1)
                  ]), 8, _hoisted_17),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sidebar-collapse-content", isCollapseOpen.value.orders ? 'is-open' : 'is-closed']),
                    id: "collapseOrdersMenu"
                  }, [
                    _createElementVNode("ul", null, [
                      (_unref(adminEfp).canAccess('orders'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                            _createVNode(_component_router_link, { to: "/adminEFP/orders" }, {
                              default: _withCtx(() => _cache[19] || (_cache[19] = [
                                _createTextVNode("Commandes Efashion")
                              ])),
                              _: 1,
                              __: [19]
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(adminEfp).canAccess('orders'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                            _createVNode(_component_router_link, { to: "/adminEFP/orders/store" }, {
                              default: _withCtx(() => _cache[20] || (_cache[20] = [
                                _createTextVNode("Commandes Store")
                              ])),
                              _: 1,
                              __: [20]
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(adminEfp).canAccess('groupages'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                            _createVNode(_component_router_link, { to: "/adminEFP/groupages" }, {
                              default: _withCtx(() => _cache[21] || (_cache[21] = [
                                _createTextVNode("Gestion des groupages")
                              ])),
                              _: 1,
                              __: [21]
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(adminEfp).canAccess('ruptures'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                            _createVNode(_component_router_link, { to: "/adminEFP/commandes-rupture" }, {
                              default: _withCtx(() => _cache[22] || (_cache[22] = [
                                _createTextVNode("Tableau des ruptures")
                              ])),
                              _: 1,
                              __: [22]
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(adminEfp).canAccess('litige-retour'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                            _createVNode(_component_router_link, { to: "/adminEFP/litige-retour" }, {
                              default: _withCtx(() => _cache[23] || (_cache[23] = [
                                _createTextVNode("Litige & retour")
                              ])),
                              _: 1,
                              __: [23]
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            (canSeeBilling.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                  _createElementVNode("span", {
                    class: "sidebar-collapse-trigger",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleCollapse('billing'))),
                    "aria-expanded": isCollapseOpen.value.billing,
                    "aria-controls": "collapseBillingMenu"
                  }, _cache[24] || (_cache[24] = [
                    _createElementVNode("span", null, [
                      _createElementVNode("i", { class: "fas fa-file-invoice-dollar" }),
                      _createTextVNode("Facturation")
                    ], -1),
                    _createElementVNode("i", { class: "chevron fas fa-chevron-right" }, null, -1)
                  ]), 8, _hoisted_24),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sidebar-collapse-content", isCollapseOpen.value.billing ? 'is-open' : 'is-closed']),
                    id: "collapseBillingMenu"
                  }, [
                    _createElementVNode("ul", null, [
                      (_unref(adminEfp).canAccess('facturation'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                            _createVNode(_component_router_link, { to: "/adminEFP/facturation" }, {
                              default: _withCtx(() => _cache[25] || (_cache[25] = [
                                _createTextVNode("Facturation")
                              ])),
                              _: 1,
                              __: [25]
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(adminEfp).canAccess('vendeur-facturation'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                            _createVNode(_component_router_link, { to: "/adminEFP/vendeur-facturation" }, {
                              default: _withCtx(() => _cache[26] || (_cache[26] = [
                                _createTextVNode("Facturation vendeurs")
                              ])),
                              _: 1,
                              __: [26]
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            (canSeeContent.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                  _createElementVNode("span", {
                    class: "sidebar-collapse-trigger",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleCollapse('content'))),
                    "aria-expanded": isCollapseOpen.value.content,
                    "aria-controls": "collapseContentMenu"
                  }, _cache[27] || (_cache[27] = [
                    _createElementVNode("span", null, [
                      _createElementVNode("i", { class: "fas fa-newspaper" }),
                      _createTextVNode("Contenu")
                    ], -1),
                    _createElementVNode("i", { class: "chevron fas fa-chevron-right" }, null, -1)
                  ]), 8, _hoisted_28),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sidebar-collapse-content", isCollapseOpen.value.content ? 'is-open' : 'is-closed']),
                    id: "collapseContentMenu"
                  }, [
                    _createElementVNode("ul", null, [
                      (_unref(adminEfp).canAccess('actualites'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                            _createVNode(_component_router_link, { to: "/adminEFP/actualites" }, {
                              default: _withCtx(() => _cache[28] || (_cache[28] = [
                                _createTextVNode("Actualités")
                              ])),
                              _: 1,
                              __: [28]
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(adminEfp).canAccess('couleurs'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                            _createVNode(_component_router_link, { to: "/adminEFP/couleurs" }, {
                              default: _withCtx(() => _cache[29] || (_cache[29] = [
                                _createTextVNode("Couleurs officielles")
                              ])),
                              _: 1,
                              __: [29]
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(adminEfp).canAccess('mel-template'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                            _createVNode(_component_router_link, { to: "/adminEFP/mel-template" }, {
                              default: _withCtx(() => _cache[30] || (_cache[30] = [
                                _createTextVNode("Données template MEL")
                              ])),
                              _: 1,
                              __: [30]
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(adminEfp).canAccess('cms'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                            _createVNode(_component_router_link, { to: "/adminEFP/store-prestations" }, {
                              default: _withCtx(() => _cache[31] || (_cache[31] = [
                                _createTextVNode("Prestations Store")
                              ])),
                              _: 1,
                              __: [31]
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(adminEfp).canAccess('cms'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                            _createVNode(_component_router_link, { to: "/adminEFP/cms/pages" }, {
                              default: _withCtx(() => _cache[32] || (_cache[32] = [
                                _createTextVNode("Pages")
                              ])),
                              _: 1,
                              __: [32]
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(adminEfp).canAccess('cms'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
                            _createVNode(_component_router_link, { to: "/adminEFP/cms/widgets" }, {
                              default: _withCtx(() => _cache[33] || (_cache[33] = [
                                _createTextVNode("Widgets")
                              ])),
                              _: 1,
                              __: [33]
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(adminEfp).canAccess('cms'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                            _createVNode(_component_router_link, { to: "/adminEFP/cms/media" }, {
                              default: _withCtx(() => _cache[34] || (_cache[34] = [
                                _createTextVNode("Médiathèque")
                              ])),
                              _: 1,
                              __: [34]
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            (_unref(adminEfp).canAccess('shooting'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                  _createElementVNode("span", {
                    class: "sidebar-collapse-trigger",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleCollapse('shooting'))),
                    "aria-expanded": isCollapseOpen.value.shooting,
                    "aria-controls": "collapseShootingMenu"
                  }, _cache[35] || (_cache[35] = [
                    _createElementVNode("span", null, [
                      _createElementVNode("i", { class: "fas fa-camera" }),
                      _createTextVNode("Shooting")
                    ], -1),
                    _createElementVNode("i", { class: "chevron fas fa-chevron-right" }, null, -1)
                  ]), 8, _hoisted_37),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sidebar-collapse-content", isCollapseOpen.value.shooting ? 'is-open' : 'is-closed']),
                    id: "collapseShootingMenu"
                  }, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'list-modeles' },
                          "active-class": "",
                          "exact-active-class": "router-link-exact-active"
                        }, {
                          default: _withCtx(() => _cache[36] || (_cache[36] = [
                            _createTextVNode("Gestion des modèles")
                          ])),
                          _: 1,
                          __: [36]
                        })
                      ]),
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'pickup-return' },
                          "active-class": "",
                          "exact-active-class": "router-link-exact-active"
                        }, {
                          default: _withCtx(() => _cache[37] || (_cache[37] = [
                            _createTextVNode("Pickup & Return")
                          ])),
                          _: 1,
                          __: [37]
                        })
                      ]),
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'agenda-shooting' },
                          "active-class": "",
                          "exact-active-class": "router-link-exact-active"
                        }, {
                          default: _withCtx(() => _cache[38] || (_cache[38] = [
                            _createTextVNode("Shooting Agenda")
                          ])),
                          _: 1,
                          __: [38]
                        })
                      ]),
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'manager-shooting' },
                          "active-class": "",
                          "exact-active-class": "router-link-exact-active"
                        }, {
                          default: _withCtx(() => _cache[39] || (_cache[39] = [
                            _createTextVNode("Manager Shooting")
                          ])),
                          _: 1,
                          __: [39]
                        })
                      ])
                    ])
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            (_unref(adminEfp).isSuperAdmin || _unref(adminEfp).canAccess('shooting'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                  _createVNode(_component_router_link, { to: { name: 'adminEFP/shopify' } }, {
                    default: _withCtx(() => _cache[40] || (_cache[40] = [
                      _createElementVNode("i", { class: "fab fa-shopify" }, null, -1),
                      _createTextVNode(" Shopify ")
                    ])),
                    _: 1,
                    __: [40]
                  })
                ]))
              : _createCommentVNode("", true),
            (_unref(adminEfp).isSuperAdmin)
              ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                  _createVNode(_component_router_link, { to: "/adminEFP/logging" }, {
                    default: _withCtx(() => _cache[41] || (_cache[41] = [
                      _createElementVNode("i", { class: "fas fa-clipboard-list" }, null, -1),
                      _createTextVNode(" Journal des actions ")
                    ])),
                    _: 1,
                    __: [41]
                  })
                ]))
              : _createCommentVNode("", true),
            (_unref(adminEfp).isSuperAdmin)
              ? (_openBlock(), _createElementBlock("li", _hoisted_40, [
                  _createVNode(_component_router_link, { to: "/adminEFP/access" }, {
                    default: _withCtx(() => _cache[42] || (_cache[42] = [
                      _createElementVNode("i", { class: "fas fa-user-shield" }, null, -1),
                      _createTextVNode(" Gestion des accès ")
                    ])),
                    _: 1,
                    __: [42]
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.isSidebarCollapsed]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_41, [
        (_unref(authStore).isImpersonating && _unref(authStore).impersonationDisplayName)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "sidebar-adminEFP-badge collapsed",
              title: 'ADMIN : ' + _unref(authStore).impersonationDisplayName
            }, " ADMIN ", 8, _hoisted_42))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "collapsed-icon",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push('/'))),
          title: "Tableau de bord"
        }, _cache[43] || (_cache[43] = [
          _createElementVNode("i", { class: "fas fa-home" }, null, -1)
        ])),
        _createElementVNode("div", {
          class: "collapsed-icon",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (navigateTo('account/infos'))),
          title: "Informations générales"
        }, _cache[44] || (_cache[44] = [
          _createElementVNode("i", { class: "fas fa-store" }, null, -1)
        ]))
      ], 512), [
        [_vShow, _ctx.isSidebarCollapsed]
      ])
    ])
  ], 2))
}
}

})